const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isValidEmail = (email) => {
    return emailRegex.test(email);
}

const isValidDate = (date) => {
    if (!date) return false;
    const dateObj = new Date(date);
    return !isNaN(dateObj.getTime());
}

const toDateTime = (seconds = Date.now() / 1000) => {
    return new Date(seconds * 1000).toISOString();
}

const toDate = (seconds = Date.now() / 1000) => {
    return toDateTime(seconds).split('T')[0];
};

const toTime = (seconds = Date.now() / 1000) => {
    return toDateTime(seconds).split('T')[1].split('.')[0];
};

const toSeconds = (date = new Date()) => {
    // Parse date as UTC
    const dateStr = date instanceof Date ? date.toISOString().split('T')[0] : date;
    const dateObj = new Date(dateStr + 'T00:00:00Z'); // Append time and Z for UTC
    return Math.floor(dateObj.getTime() / 1000);
}

const toActualSeconds = (date = new Date()) => {
    // Parse date as UTC
    const dateObj = date instanceof Date ? date : new Date(date);
    return Math.floor(dateObj.getTime() / 1000);
}

const toDateTimeLocal = (seconds = Date.now() / 1000, options = {}) => {
    return new Date(toDateTime(seconds)).toLocaleString("en-IN", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, hour12: true, year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZoneName: 'short', ...options });
}

const getDateDiffText = (date = new Date()) => {
    const age = getDateDiff(date);
    if (!age) {
        return '';
    } 

    let ageStr = '';

    if (age.years > 0) {
        ageStr += `${age.years} year${age.years > 1 ? 's' : ''}`;
    }
    if (age.months > 0) {
        if (ageStr) ageStr += ', ';
        ageStr += `${age.months} month${age.months > 1 ? 's' : ''}`;
    }
    if (age.days > 0) {
        if (ageStr) ageStr += ', ';
        ageStr += `${age.days} day${age.days > 1 ? 's' : ''}`;
    }

    return age.future ? `In ${ageStr}` : ageStr ? `${ageStr}` : 'Today';

}

const getDateDiff = (date = new Date()) => {
    if (!isValidDate(date)) {
        return null;
    }

    const now = new Date();
    let date1 = date > now ? now : date;
    let date2 = date > now ? date : now;

    let ageYears = date2.getFullYear() - date1.getFullYear();
    let ageMonths = date2.getMonth() - date1.getMonth();
    let ageDays = date2.getDate() - date1.getDate();

    if (ageDays < 0) {
        ageMonths -= 1;
        ageDays += new Date(date2.getFullYear(), date2.getMonth(), 0).getDate(); // Days in previous month
    }
    if (ageMonths < 0) {
        ageYears -= 1;
        ageMonths += 12;
    }

    return { years: ageYears, months: ageMonths, days: ageDays, future: date > now };
}


export { 
    isValidEmail,
    isValidDate,
    toDateTime,
    toDate,
    toTime,
    toDateTimeLocal,
    toSeconds,
    toActualSeconds,
    getDateDiff,
    getDateDiffText
};